export default {
  storeCriteriaCategoryList(state, criteriaCategories) {
    state.criteriaCategories = criteriaCategories;
  },
  storeCriteriaCategory(state, criteriaCategory) {
    state.criteriaCategory = criteriaCategory;
  },
  storeSubCriteriaCategory(state, subCriteriaCategory) {
    state.subCriteriaCategory = subCriteriaCategory;
  },

  storeUpdatedCriteriaCategory(state,updatedCriteriaCategory) {
    state.criteriaCategory = updatedCriteriaCategory
  },

  storeUpdatedSubCriteriaCategory(state,updatedSubCriteriaCategory) {
    state.subCriteriaCategory = updatedSubCriteriaCategory
  },
  storeCreatedCriteriaCategory(state,createdCriteriaCategory) {
    state.criteriaCategories << createdCriteriaCategory
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/criteria_categories/mutations.js